import React, { useRef } from 'react';
import { connect } from 'react-redux';

import styled from 'styled-components';

import AuthPromoTextPopup from 'components/calculator/AuthPromoTextPopup';

import { ALIPAY_FREE, MASTERCARD_FREE } from 'constants/FieldType';

import { URL_IMAGES_PAYSYSTEMS } from '../../constants/UrlConstants';
import zIndex from '../../theme/zIndex';
import { NavBar } from '../common/Layout/NavBar/NavBar';
import { Row } from '../common/Layout/Row';
import PopupNew from '../common/Popup/PopupNew';
import { Text } from '../common/Text/Text';

const IconWrapper = styled.div`
    margin-right: 24px;
`;

const MainWrapper = styled.div`
    z-index: ${zIndex.promoBanner};
`;

const AuthPromoBanner = (props) => {
    const popupRef = useRef(null);
    const isComponentType = (type) => props.component !== null && props.component.type === type;

    const getIcon = () => {
        if (isComponentType(ALIPAY_FREE)) {
            return { url: `${URL_IMAGES_PAYSYSTEMS}/alipay.svg` };
        } else if (isComponentType(MASTERCARD_FREE)) {
            return { url: `${URL_IMAGES_PAYSYSTEMS}/mastercard_color.svg` };
        }
    };

    if (isComponentType(ALIPAY_FREE) || isComponentType(MASTERCARD_FREE)) {
        return (
            <>
                <MainWrapper>
                    <NavBar align="center">
                        <IconWrapper>
                            <img src={getIcon()} alt={'paysystem'} />
                        </IconWrapper>
                        <Row flex direction="column">
                            <Text>{props.component.title}</Text>
                            <Text
                                variant="button"
                                color="purple"
                                onClick={() =>
                                    popupRef.current?.open(
                                        <AuthPromoTextPopup
                                            popupRef={popupRef}
                                            countryToId={props.countryToId}
                                            isComment
                                            text={props.component.modalBlockText}
                                        />,
                                    )
                                }
                            >
                                {props.component.moreText}
                            </Text>
                        </Row>
                    </NavBar>
                </MainWrapper>
                <PopupNew ref={popupRef} />
            </>
        );
    } else {
        return null;
    }
};

const mapStateToProps = (state) => {
    return {
        countryToId: state.extra.countryToId,
        component: state.app.authPromoAction,
    };
};

export default connect(mapStateToProps, null)(AuthPromoBanner);
